export interface DepositActionRuleDTO {
  id?: number;
  minFraudScore: number;
  minFraudScoreType: LimitType;
  maxFraudScore: number;
  maxFraudScoreType: LimitType;
}

export enum LimitType {
  NO_LIMIT = 'NO_LIMIT',
  EXCLUSIVE = 'EXCLUSIVE',
  INCLUSIVE = 'INCLUSIVE',
}
